import React from 'react';
import { DropDownList } from 'components/formInputs/dropDownList';
import { Input } from 'components/formInputs/input';
import { FilterBlock, FilterField } from 'components/layouts/filterBlock';

export const OrdersFilter = ({
  onClearFilters, isClosedLoading, isProcessingLoading, onFilterOrders,
  filterFromDate, setFilterFromDate, filterToDate, setFilterToDate, filterRestaurant, setFilterRestaurant,
  filterTable, setFilterTable, filterText, setFilterText, filterType, setFilterType, restaurants, tables, filterSnapshot,
  filterquickDateOption, setFilterQuickDateOption,
}) => {
  const renderDateButton = (text, daysBack) => {
    return (
      <button
        type="button"
        onClick={() => {
          setFilterQuickDateOption(daysBack);
        }}
        className={` py-1 px-2 border  rounded-md shadow-sm text-sm font-medium inline-flex justify-center
          items-center disabled:opacity-50 mr-2 mt-2
          ${filterquickDateOption === daysBack
          ? 'text-white bg-indigo-600  hover:bg-indigo-700 border-transparent'
          : 'text-gray-700 bg-white hover:bg-gray-50 border-gray-300'}`}
      >
        {text}
      </button>
    );
  };

  return (
    <FilterBlock
      canMinimize
      buttons={[
        {
          onPress: onClearFilters,
          text: 'Clear',
          class: 'bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 inline-flex justify-center items-center hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50',
          disabled: !!isClosedLoading || !!isProcessingLoading,
        },
        {
          onPress: onFilterOrders,
          text: 'Search',
          class: 'ml-3 bg-indigo-600 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center items-center text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50',
          disabled: !!isClosedLoading || !!isProcessingLoading,
          isLoading: !!isClosedLoading || !!isProcessingLoading,
        },
      ]}
      getMinimizedTexts={() => {
        const texts = [];

        if (filterSnapshot.quickDateOption === 0) {
          texts.push({ label: 'Date', value: 'Today' });
        } else if (filterSnapshot.quickDateOption === 7) {
          texts.push({ label: 'Date', value: 'Last 7 days' });
        } else if (filterSnapshot.quickDateOption === 30) {
          texts.push({ label: 'Date', value: 'Last 30 days' });
        } else if (filterquickDateOption === -1) {
          if (filterSnapshot.fromDate) {
            texts.push({ label: 'Date from', value: filterSnapshot.fromDate });
          }

          if (filterSnapshot.toDate) {
            texts.push({ label: 'Date to', value: filterSnapshot.toDate });
          }
        }

        if (filterSnapshot.restaurant) {
          const foundRestaurant = restaurants?.find((x) => x._id === filterSnapshot.restaurant);

          texts.push({ label: 'Restaurant', value: foundRestaurant?.name });
        }

        if (filterSnapshot.table) {
          const foundTable = tables?.find((x) => x._id === filterSnapshot.table);

          texts.push({ label: 'Table', value: foundTable?.name || foundTable?.number });
        }

        if (filterSnapshot.number) {
          texts.push({ label: 'Search', value: filterSnapshot.number });
        }

        return texts;
      }}
    >
      <FilterField isFullLength>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Date
          </label>
          {renderDateButton('Today', 0)}
          {renderDateButton('Last 7 days', 7)}
          {renderDateButton('Last 30 days', 30)}
          {renderDateButton('Custom', -1)}
        </div>
      </FilterField>

      {filterquickDateOption === -1 && (
      <FilterField>
        <div>
          <label htmlFor="fromDate" className="block text-sm font-medium text-gray-700">
            Date from
          </label>
          <div className="mt-1 relative text-sm text-gray-500">
            <Input
              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
              name="fromDate"
              id="fromDate"
              type="text"
              value={filterFromDate}
              onChange={(e) => {
                setFilterFromDate(e.target.value);
              }}
              onEnterClicked={() => {
                onFilterOrders();
              }}
              placeholder="YYYY-MM-DD"
              onFocus={(event) => event.target.select()}
            />
          </div>
        </div>
      </FilterField>
      )}
      {filterquickDateOption === -1 && (
      <FilterField>
        <div>
          <label htmlFor="toDate" className="block text-sm font-medium text-gray-700">
            Date to
          </label>
          <div className="mt-1 relative text-sm text-gray-500">
            <Input
              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
              name="toDate"
              id="toDate"
              type="text"
              value={filterToDate}
              onChange={(e) => setFilterToDate(e.target.value)}
              onEnterClicked={() => {
                onFilterOrders();
              }}
              placeholder="YYYY-MM-DD"
              onFocus={(event) => event.target.select()}
            />
          </div>
        </div>
      </FilterField>
      )}
      <FilterField>
        <DropDownList
          showLabel
          id="restaurants"
          name="restaurants"
          label="Restaurant"
          value={filterRestaurant}
          onChange={(e) => {
            setFilterRestaurant(e.target.value);
            setFilterTable('');
          }}
          options={[{ label: 'All', value: '' }, ...(restaurants || []).map((restaurant) => ({
            label: restaurant.name,
            value: restaurant._id,
          }))]}
          className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
        />
      </FilterField>
      <FilterField>
        <DropDownList
          showLabel
          id="table"
          name="table"
          label="Table"
          value={filterTable}
          onChange={(e) => {
            setFilterTable(e.target.value);
          }}
          options={[{ label: '-', value: '' }, ...(tables?.map((table) => ({
            label: `${table.name || table.number}`,
            value: table._id,
          })) || [])]}
          className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
        />
      </FilterField>
      <FilterField>
        <DropDownList
          showLabel
          id="type"
          name="type"
          label="Type"
          value={filterType}
          onChange={(e) => {
            setFilterType(e.target.value);
          }}
          options={[{ label: '-', value: '' }, { label: 'Dine-In', value: 'dineIn' }, { label: 'Takeaway / Delivery', value: 'delivery' }]}
          className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
        />
      </FilterField>
      <FilterField>
        <div>
          <label htmlFor="search" className="block text-sm font-medium text-gray-700">
            Search (Order ID)
          </label>
          <div className="mt-1 relative text-sm text-gray-500">
            <Input
              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
              name="search"
              id="search"
              type="text"
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
              onEnterClicked={() => {
                onFilterOrders();
              }}
              onFocus={(event) => event.target.select()}
            />
          </div>
        </div>
      </FilterField>
    </FilterBlock>
  );
};
